module.exports = __webpack_public_path__ + "static/media/davey-tree.b943a8a0.png";